<div class="phone-shell">
  <div class="phone-shell__frame">
    <div class="phone-shell__viewport">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
